import React, { ReactNode, useContext } from "react";
import { DefaultLayoutProp } from "../default-layout/DefaultLayout";
import { AppContext } from "@vahak/core/dist/app-context";
import SideNavLayoutWrapper from "../SideNavLayoutWrapper/SideNavLayoutWrapper";
import DefaultLayoutWrapper from "../DefaultLayoutWrapper/DefaultLayoutWrapper";

interface IMembershipLayoutWrapper extends DefaultLayoutProp {
    children: ReactNode;
    pageRoute?: string;
}

export const MembershipLayoutWrapper = ({ ...props }: IMembershipLayoutWrapper) => {
    const { isPhoneVerified, companyId } = useContext(AppContext);
    const { content: Content, children, navContent, pageRoute } = props;

    if (isPhoneVerified && companyId) {
        return <SideNavLayoutWrapper>{children}</SideNavLayoutWrapper>;
    } else {
        return <DefaultLayoutWrapper navContent={navContent}>{children}</DefaultLayoutWrapper>;
    }
};
